import { ContentTypeFilter } from '@emerald-works-nova/components'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'
import FilterBar from '../filter-bar'
import { DropdownFilter, RangeSliderFilter } from '../filters'

export const useStyles = makeStyles(({ spacing, palette }) => ({
  root: {}
}))

const SearchFilterBar = props => {
  const {
    disabled,
    counts = { time: { max: 120 } },
    // sorters,
    values,
    onApply: handleApply,
    onClearAll
  } = props

  const classes = useStyles(props)

  /* eslint-disable react/jsx-key */
  const filters = [
    <ContentTypeFilter name='type' disabled={disabled} showScrollbar types={counts?.types} />,
    <RangeSliderFilter
      name='time'
      label='Time'
      range={{ labels: ['Start Time', 'End Time'], values: [0, counts.time.max], unit: 'mins' }}
      disabled={disabled}
    />,
    <DropdownFilter
      name='keywords'
      label='Keywords'
      options={counts.keywords}
      multiple
      disabled={disabled}
    />
  ]
  /* eslint-enable react/jsx-key */

  // const sorter = (
  //   <DropdownFilter
  //     name='sort'
  //     options={sorters.map(s => ({ key: s }))}
  //     disabled={disabled}
  //   />
  // )

  return (
    <FilterBar
      filters={filters}
      // sorter={sorter}
      values={values}
      onClearAll={onClearAll}
      onApply={handleApply}
      disabled={disabled}
      classes={{ root: classes.root }}
    />
  )
}

export default SearchFilterBar
